import { createContext } from 'react';

const CoreDialogContext = createContext({});

export default CoreDialogContext;
